import styled from 'styled-components';
import { Button, Col, Form, Input, Select } from 'antd';

import { Text } from '@/components/Typography';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

export const Content = styled(Col)`
	padding: 35px 40px;
	border-radius: 18px;
	background-color: #ffffff;
`;

export const FormItem = styled(Form.Item)`
	position: relative;
	margin: 0;
	.ant-form-item-explain-error {
		position: absolute;
		white-space: nowrap;
	}
`;

export const CustomInput = styled(Input)`
	border-radius: 6px;
`;

export const CustomSelect = styled(Select)`
	.ant-select-selector {
		display: flex;
		align-items: center;
		padding: 0 8px !important;
		border-radius: 6px !important;
	}
`;

export const RoundedButton = styled(Button)`
	border: none;
	color: #ffffff;
	border-radius: 50%;
	background-color: ${DEFAULT_RISK_RPN_COLOR};
	box-shadow: -2px 2px 4px 0px #00000040;
`;

export const Label = styled(Text)`
	font-weight: 600;
`;

export const Item = styled(Col)`
	border-radius: 6px;
	border: 2px solid #d9d9d9;
	background-color: #f8f8f8;
	.column {
		padding: 8px 0 8px 10px;
		border-right: 2px solid #d9d9d9;
		button {
			border: none;
			color: ${DEFAULT_RISK_RPN_COLOR};
			background: transparent;
			svg {
				font-size: 25px;
			}
			&:disabled {
				color: #d9d9d9;
			}
		}
		button.ant-btn-dangerous {
			color: #ff4d4f;
			background: transparent;
		}
		&:last-child {
			display: flex;
			align-items: center;
			justify-content: center;
			border: none;
			padding: 0;
		}
	}
`;
